
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { CheckCircle, Lock } from "lucide-react";
import elabAPI from "../../libs/api/elab";

const LEVEL_STYLES = {
  B1: {
    free: "bg-gradient-to-br from-purple-500 to-purple-600 text-white",
    premium: "bg-gradient-to-br from-purple-100 to-purple-200 text-purple-900",
    button: {
      free: "bg-white text-purple-600 hover:bg-purple-50",
      premium: "bg-purple-600 hover:bg-purple-700 text-white",
    },
    progressBar: {
      free: "bg-white",
      premium: "bg-purple-600",
    },
    badge: {
      free: "bg-white text-purple-600",
      premium: "bg-purple-600 text-white",
    },
  },
  B2: {
    free: "bg-gradient-to-br from-orange-500 to-orange-600 text-white",
    premium: "bg-gradient-to-br from-orange-100 to-orange-200 text-orange-900",
    button: {
      free: "bg-white text-orange-600 hover:bg-orange-50",
      premium: "bg-orange-500 hover:bg-orange-600 text-white",
    },
    progressBar: {
      free: "bg-white",
      premium: "bg-orange-500",
    },
    badge: {
      free: "bg-white text-orange-600",
      premium: "bg-orange-600 text-white",
    },
  },
  C1: {
    free: "bg-gradient-to-br from-pink-500 to-pink-600 text-white",
    premium: "bg-gradient-to-br from-pink-100 to-pink-200 text-pink-900",
    button: {
      free: "bg-white text-pink-600 hover:bg-pink-50",
      premium: "bg-pink-500 hover:bg-pink-600 text-white",
    },
    progressBar: {
      free: "bg-white",
      premium: "bg-pink-500",
    },
    badge: {
      free: "bg-white text-pink-600",
      premium: "bg-pink-600 text-white",
    },
  },
};

export function TestCard({
  testNumber,
  isPremium,
  progress,
  level,
  skill,
  status,
  assignmentId,
  testId,
  Upgradetoggle,
}) {
  const styles = LEVEL_STYLES[level];
  const cardStyle = isPremium ? styles.premium : styles.free;
  const isInProgress = status === "In progress";
  const isCompleted =
    status === "Task completed" ||
    status === "Submitted late" ||
    status === "Pending";

  const handleTestStart = async () => {
    if (isCompleted && assignmentId) {
      window.location.href = `/elab/test-performance/${assignmentId}/`;
      return;
    } else if (assignmentId) {
      window.location.href = `/elab/quiz/${assignmentId}?type=assessment`;
      return;
    }

    try {
      const response = await elabAPI.getStartTestUrl(testId);
      const data = await response.json();

      if (data?.redirect_url) {
        window.location.href = data.redirect_url;
      }
    } catch (error) {
      console.error("Error starting test:", error);
    }
  };

  return (
    <>
      <Card
        className={`${cardStyle} overflow-hidden transition-all duration-300 hover:shadow-lg`}
      >
        <div className="p-6 space-y-4">
          <div className="flex justify-between items-center">
            <h3 className="text-2xl font-bold">{skill}</h3>
            <div
              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                isPremium ? styles.badge.premium : styles.badge.free
              }`}
            >
              {isPremium ? (
                <div className="flex items-center gap-1">
                  <Lock className="w-3 h-3" />
                  Premium
                </div>
              ) : (
                <div className="flex items-center gap-1">
                  <CheckCircle className="w-3 h-3" />
                  Free
                </div>
              )}
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className={isPremium ? "" : "text-white/90"}>Progress</span>
              <span className="font-medium">{progress}%</span>
            </div>
            <div className="h-2 bg-black/10 rounded-full overflow-hidden">
              <div
                className={`h-full ${
                  isPremium
                    ? styles.progressBar.premium
                    : styles.progressBar.free
                }`}
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          <Button
            className={`w-full h-12 text-lg font-medium rounded-xl ${
              isPremium
                ? styles.button.premium
                : "bg-white hover:bg-white/90 text-gray-900"
            }`}
            variant="default"
            onClick={() => {
              if (isPremium && !isCompleted && !isInProgress) {
                Upgradetoggle();
              } else {
                handleTestStart();
              }
            }}
          >
            {isCompleted
              ? "Test Result"
              : isInProgress
              ? "Continue Test"
              : isPremium
              ? "Unlock Premium Test"
              : "Start Test"}
          </Button>
        </div>
      </Card>
    </>
  );
}
